import React, {Fragment, PropsWithChildren, useRef, useState} from 'react';
import b_ from 'b_';
import {TumblerProps} from '@yandex-lego/components/Tumbler';

import {Popup, Tumbler} from 'client/common/components/lego';
import IconButton from 'client/common/components/icon-button';

import './block.css';

const b = b_.with('block');

type BlockPopupProps = PropsWithChildren<React.ReactNode>;

function BlockPopup(props: BlockPopupProps) {
    const {children} = props;

    const iconRef = useRef(null);
    const [isPopupClicked, setIsPopupClicked] = useState(false);

    function togglePopup() {
        setTimeout(() => setIsPopupClicked(!isPopupClicked), 0);
    }

    return (
        <Fragment>
            <IconButton
                type='help'
                innerRef={iconRef}
                className={b('icon', {type: 'help'})}
                onClick={togglePopup}
            />
            <Popup
                className={b('popup')}
                target='anchor'
                anchor={iconRef}
                view='default'
                direction={['bottom-end', 'bottom', 'bottom-start']}
                visible={isPopupClicked}
                onClose={togglePopup}
            >
                {children}
            </Popup>
        </Fragment>
    );
}

type BlockProps = PropsWithChildren<{
    header?: React.ReactNode;
    description?: React.ReactNode;
    popupContent?: React.ReactNode;
    tumbler?: TumblerProps;
    link?: {
        text: string;
        link: string;
    }
} & React.HTMLProps<HTMLDivElement>>;

export default function Block(props: BlockProps) {
    const {
        children,
        className = '',
        header,
        description,
        popupContent,
        tumbler,
        link,
        ...divProps
    } = props;

    const withTumbler = Boolean(tumbler && !tumbler.labelBefore);
    const tumblerWithLabel = Boolean(tumbler?.labelBefore);

    return <div className={`${b()} ${className}`} {...divProps}>
        {(header || link || tumbler) && <div className={b('header')}>
            {header && <div className={b('title', {withTumbler})}>
                {header}
                {popupContent && <BlockPopup>{popupContent}</BlockPopup>}
            </div>}
            {link && <a
                className={b('link')}
                href={link.link}
                target='_blank'
                rel='noopener
                noreferrer'
            >{link.text}</a>}
            {tumbler && <Tumbler
                {...tumbler}
                className={b('tumbler', {'with-label': tumblerWithLabel})}
                size='m'
                view='dl'
            />}
        </div>}
        {description && <h3 className={`${b('description')}`}>
            {description}
        </h3>}
        {children}
    </div>;
}
